module.exports = __webpack_public_path__ + "img/Antigua-&-Barbuda.6c82f3cc.png";